const tpProductDetail = (function () {
  return {
    init: function () {
      const mediaGalleryPrd = document.querySelector('media-gallery');
      const galleryLayout = mediaGalleryPrd?.dataset.galleryLayout;
      this.swiperPrd(galleryLayout);
      this.clickShowModalPrd();
      this.setHeightElThumbLeftThumbRight(galleryLayout);
      this.activeTabDesktop();
      this.collapTabMobile();
      this.clickPopupShare();
      this.clickPopupSizeGuide();
      this.copyUrlPrd();
      this.checkFormInfo();
      this.checkedBuyItNow();
      this.stickyPrdDetail();
      this.sizeChartMaxSale();
    },
    swiperPrd: function (galleryLayout) {
      if (!galleryLayout) return;
      let direction = 'horizontal';
      let slidesPerView = 6;
      let thumbSwiper = '';
      const isMobile = innerWidth <= 768;
      if (galleryLayout == 'thumbnails_left' || galleryLayout == 'thumbnails_right') {
        direction = 'vertical';
      }
      if (innerWidth <= 1024) {
        direction = 'horizontal';
        slidesPerView = isMobile ? 'auto' : 5;
      }
      const thumbnail = document.querySelector('.swiper-thumbnail');
      if (galleryLayout != 'no_thumbnails' && thumbnail) {
        window.productThumb = new Swiper(".swiper-thumbnail", {
          spaceBetween: isMobile ? 10 : 12,
          slidesPerView: slidesPerView,
          freeMode: true,
          watchSlidesProgress: true,
          direction: direction,
          navigation: {
            nextEl: ".swiper-next-main-prd",
            prevEl: ".swiper-prev-main-prd",
          },
        });
        thumbSwiper = productThumb;
      }

      // Bambe perf: avoid Swiper MutationObservers on every DOM change (hurts INP).
      // Product gallery media is static after load; slideTo still works without observers.
      window.productMain = new Swiper(".swiper-main-prd", {
        spaceBetween: 0,
        slidesPerView: 1,
        watchOverflow: true,
        observer: false,
        observeParents: false,
        a11y: {
          nextSlideMessage: 'الشريحة التالية',
          prevSlideMessage: 'الشريحة السابقة',
        },
        navigation: {
          nextEl: ".swiper-next-main-prd",
          prevEl: ".swiper-prev-main-prd",
        },
        thumbs: {
          swiper: thumbSwiper,
        },
      });
    },
    clickShowModalPrd: function () {
      // Lazy-init modal Swiper on first open (saves main-thread work on PDP load)
      let modalPrd = null;
      const ensureModalSwiper = () => {
        if (modalPrd || !document.querySelector('.js-tp-modal-prd')) return modalPrd;
        try {
          modalPrd = new Swiper(".js-tp-modal-prd", {
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: {
              nextEl: ".swiper-next-tp-modal-prd",
              prevEl: ".swiper-prev-tp-modal-prd",
            },
          });
        } catch (err) {
          console.error(err);
          modalPrd = null;
        }
        return modalPrd;
      };
      document.addEventListener('click', function (e) {
        const el = e.target;
        const tpModalPrd = document.querySelector('.tp-modal-prd');
        if (!tpModalPrd) return;
        if (el.classList.contains('click-modal-prd')) {
          const dataIndex = parseInt(el.closest('.swiper-slide').dataset.indexModal);
          tpModalPrd.classList.add('show-modal-prd');
          const swiper = ensureModalSwiper();
          if (swiper) swiper.slideTo(dataIndex, 0);
        }
        if (el.classList.contains('tp-icon-close-prd')) {
          tpModalPrd.classList.remove('show-modal-prd');
        }

      })
    },
    setHeightElThumbLeftThumbRight: function (galleryLayout) {
      // setHeight slide
      if (!galleryLayout) return;
      if (galleryLayout != 'thumbnails_bottom' && innerWidth > 1024) {
        let box = null;

        box = document.querySelector('.swiper-main-prd img') ||
          document.querySelector('.swiper-main-prd video') ||
          document.querySelector('.swiper-main-prd iframe');

        if (!box || box.clientHeight === 0) {
          box = document.querySelector('.swiper-main-prd .swiper-slide-active');
        }

        const tpImgThumb = document.querySelector(".swiper-thumbnail");

        if (tpImgThumb && box && box.clientHeight > 0) {
          tpImgThumb.style.height = box.clientHeight + "px";
        }
      }
    },
    activeTabDesktop: function () {
      const prd_tab = document.querySelector('.tp-product-tabs');
      if (!prd_tab) return;
      document.addEventListener('click', function (e) {
        const el = e.target;
        if (el.classList.contains('js-tab-item')) {
          const parentNode = el.parentNode
          parentNode.querySelector('.active').classList.remove('active');
          el.classList.add('active')
          const tabContents = document.querySelectorAll('.js-prd-tab-content');
          if (tabContents.length > 0) {
            tabContents.forEach(function (tabContent) {
              if (tabContent.getAttribute('data-number') === el.getAttribute('data-number')) {
                tabContent.classList.add('active');
                tabContent.classList.remove('md:hidden');
              }
              else {
                tabContent.classList.add('md:hidden');
                tabContent.classList.remove('active');
              }
            })
          }
        }
      })
    },
    collapTabMobile: function () {
      if (innerWidth < 768) {
        const collapTabs = document.querySelectorAll('.tp-collap-tab');
        const parentTab = document.querySelector('.tp-product-tabs__inner');
        if (parentTab && !parentTab.classList.contains('tp-collap-tab-main')) {
          parentTab.classList.add('tp-collap-tab-main');
        }
        if (collapTabs.length == 0) return;
        collapTabs.forEach(function (collapTab) {
          if (collapTab.hasAttribute('open')) {
            collapTab.removeAttribute('open')
          }
        })

      }
    },
    clickPopupShare: function () {
      const overlayBody = document.querySelector('.tp-close-overlay');
      document.addEventListener('click', function (e) {
        const el = e.target;
        const productColumnSticky = document.querySelector('.product__info-container');

        if (el.classList.contains('button-popup')) {
          const parentNode = el.closest('.tp-popup-parent');
          const content = parentNode.querySelector('.tp-popup-parent__content');
          if (productColumnSticky.classList.contains('product__column-sticky')) {
            productColumnSticky.classList.remove('product__column-sticky');
          }
          overlayBody.classList.add('is-visible-popup-detail');
          content.classList.add('open');

        }
        if (el.classList.contains('close-popup') || !el.closest('.tp-popup-parent__content') && !el.classList.contains('button-popup')) {
          const contents = document.querySelectorAll('.tp-popup-parent__content');
          overlayBody.classList.remove('is-visible-popup-detail');
          contents.forEach(element => {
            element.classList.remove('open');
          });

        }
      });
    },
    clickPopupSizeGuide: function () {
      const overlayBody = document.querySelector('.tp-close-overlay');
      document.addEventListener('click', function (e) {
        const el = e.target;

        if (el.classList.contains('button-popup-size-guide')) {
          const parentNode = el.closest('.tp-popup-parent');
          const content = parentNode.querySelector('.tp-popup-parent__content');
          if (productColumnSticky.classList.contains('product__column-sticky')) {
            productColumnSticky.classList.remove('product__column-sticky');
          }
          overlayBody.classList.add('is-visible-popup-detail');
          content.classList.add('open');

        }
        if (el.classList.contains('close-popup') || !el.closest('.tp-popup-parent__content') && !el.classList.contains('button-popup')) {
          const contents = document.querySelectorAll('.tp-popup-parent__content');
          overlayBody.classList.remove('is-visible-popup-detail');
          contents.forEach(element => {
            element.classList.remove('open');
          });

        }
      });
    },
    checkFormInfo() {
      const urlInfo = window.location.href;
      const overlayBody = document.querySelector('.tp-close-overlay');
      const formInfo = document.querySelector('.form-infor');
      const formErr = document.querySelector('.form-infor-body.noti-error');
      const formSuccess = document.querySelector('.form-infor-body.noti-success');
      document.querySelector('.form-infor,.close-form-info').addEventListener('click', (e) => {
        const target = e.currentTarget;

        const closet = target.closest('.form-infor');
        e.preventDefault();
        if (closet.classList.contains('show-noti-form')) {
          closet.classList.remove('show-noti-form')
          overlayBody.classList.remove('is--visible-form-info');
          document.querySelector('html').classList.remove('tp-over-flow-hidden-form-info');
        };
      });
      if (urlInfo.indexOf('contact_posted=true') >= 1) {
        formInfo.classList.add('show-noti-form');
        overlayBody.classList.add('is--visible-form-info');
        document.querySelector('html').classList.add('tp-over-flow-hidden-form-info');
        formErr.style.display = "none";
        const newURL = location.href.split("?")[0];
        window.history.pushState('object', document.title, newURL);
      };
      if (urlInfo.indexOf('contact%5Btags%5D=newsletter&form_type=contact') >= 1) {
        formInfo.classList.add('show-noti-form');
        overlayBody.classList.add('is--visible-form-info');
        document.querySelector('html').classList.add('tp-over-flow-hidden-form-info')
        formSuccess.style.display = "none";
        const newURL = location.href.split("?")[0];
        window.history.pushState('object', document.title, newURL);
      }
    },
    copyUrlPrd: function () {
      const copyButton = document.querySelector('.product-share__link');
      if (!copyButton) return;
      const textCopied = document.querySelector('.text-copied');
      let timeoutId = null;
      const copyUrl = copyButton.getAttribute('data-url');
      copyButton.addEventListener('click', (e) => {
        navigator.clipboard.writeText(copyUrl);
        copyButton.classList.add('hidden');
        textCopied.classList.remove('hidden');
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          textCopied.classList.add('hidden');
          copyButton.classList.remove('hidden');
        }, 2000);
      });
    },
    checkedBuyItNow: function () {
      const agreeTerms = document.querySelector('.agree_terms_conditions');
      if (!agreeTerms) return;

      const sync = () => {
        if (typeof window.bambeSyncOrderNowButton === 'function') {
          window.bambeSyncOrderNowButton();
        }
      };

      sync();
      agreeTerms.addEventListener('change', sync);
    },
    stickyPrdDetail: function () {
      const stickyPrdDetail = document.querySelector('.sticky-product-detail');
      if (!stickyPrdDetail) return;
      scrollStickAtc();
      changeVatiant();
      function scrollStickAtc() {
        const rawThreshold = parseFloat(stickyPrdDetail.getAttribute('data-scroll-threshold') || '60');
        const thresholdPct = Math.min(90, Math.max(0, Number.isFinite(rawThreshold) ? rawThreshold : 60));
        const threshold = thresholdPct / 100;

        function updateStickyVisibility() {
          const footerBottom = document.querySelector('.footer__bottom');
          const scrollable = Math.max(
            document.documentElement.scrollHeight - window.innerHeight,
            1
          );
          const progress = window.scrollY / scrollable;
          let hide = progress < threshold;

          if (!hide && footerBottom) {
            const positionFt = footerBottom.getBoundingClientRect();
            if (positionFt.bottom <= window.innerHeight) {
              hide = true;
            }
          }

          stickyPrdDetail.style.bottom = hide
            ? '-' + stickyPrdDetail.clientHeight + 'px'
            : '0';
        }

        let stickyRaf = 0;
        const scheduleStickyUpdate = () => {
          if (stickyRaf) return;
          const tick = () => {
            stickyRaf = 0;
            updateStickyVisibility();
          };
          if (typeof requestAnimationFrame === 'function') {
            stickyRaf = requestAnimationFrame(tick);
          } else {
            stickyRaf = setTimeout(tick, 16);
          }
        };
        window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
        window.addEventListener('resize', scheduleStickyUpdate);
        updateStickyVisibility();
      }
      function changeVatiant() {
        const selectSticky = stickyPrdDetail.querySelector('.select__select');
        if (!selectSticky) return;
        selectSticky.addEventListener('change', function (e) {
          const el = e.target;
          const dataOption = selectSticky.options[selectSticky.selectedIndex];
          const inputVariantAtc = document.querySelectorAll('.product-variant-id');

          const price = dataOption.getAttribute('data-price');
          const priceCompare = dataOption.getAttribute('data-price-compare');
          inputVariantAtc.forEach(function (input) {
            input.value = el.value;
          })
          const renderPrice = new VariantSelects();
          // Pass sticky element so renderPrice uses it as parent (not a bare boolean)
          renderPrice.renderPrice(price, priceCompare, stickyPrdDetail);
        })
      }

    },
    sizeChartMaxSale: function () {

      const parenSizeChart = document.querySelector('.sfp-size-chart');
      if (!parenSizeChart) return;

      const sizeChartInterval = setInterval(openSizeChart, 500);
      document.addEventListener('click', function (e) {
        closeSizeChart(e)
      })

      function openSizeChart() {
        const btnSize = parenSizeChart.querySelector('.size-chart-btn');
        if (!btnSize) return;
        clearInterval(sizeChartInterval);
        const productColumnSticky = document.querySelector('.product__info-container');
        if (productColumnSticky.classList.contains('product__column-sticky')) {
          productColumnSticky.classList.remove('product__column-sticky');
        }

        btnSize.addEventListener('click', function () {
          const html = document.querySelector('html');
          const overlayBody = document.querySelector('.tp-close-overlay');
          html.classList.add('tp-over-flow-hidden-sizechart');
          overlayBody.classList.add('is-visible-sizechart');
        })
      }
      function closeSizeChart(e) {
        const html = document.querySelector('html');
        const overlayBody = document.querySelector('.tp-close-overlay');
        const el = e.target;
        if (el.classList.contains('button-close') || el == overlayBody && !el.classList.contains('size-chart-btn')) {
          html.classList.remove('tp-over-flow-hidden-sizechart');
          overlayBody.classList.remove('is-visible-sizechart');
        }
      }
    }
  }
})()
tpProductDetail.init()
document.addEventListener("shopify:section:load", tpProductDetail);
document.addEventListener("shopify:section:unload", tpProductDetail);



